import { useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Title from "../../../Title";
import DatosCliEnv from "./datos/DatosCliEnv";
import DireccionesEntregaEnv from "./direcciones/DireccionesEntregaEnv";
import PedidosFicha from "./pedidos/PedidosFicha";
import PrecioEspecialCliente from "./preciosEspeciales/PrecioEspecialCliente";
import CuentaCteCliente from "./cuentacorriente/CuentaCteCliente";
import IIBBclienteEnvasado from "./impuestos/IIBBclienteEnvasado";
import CuentaCorrientePage from "../cuentaCorrienteEnvasado/pages/CuentaCorrientePage";

function FichaCliEnv(props) {
  const [datosformulario, setDatosformulario] = useState(props.datos);
  /************************************************************************************************/
  // console.log("datos formulario",datosformulario);
  // console.log(localStorage.getItem("suc_auth"), datosformulario.id_sucursal);

  const sucAuthStr = localStorage.getItem("suc_auth");
  let sucAuthArray = [];
  let isEditable = false;
  let rol = localStorage.getItem("role");
  let sector = localStorage.getItem("sector");
  let controlador = Number(localStorage.getItem("controlador"));

  if (sucAuthStr) {
    sucAuthArray = sucAuthStr.split(",").map((item) => item.trim());
    isEditable = sucAuthArray.includes(String(datosformulario.id_sucursal));
  }

  // Definición de veCtaCte
  let veCtaCte = false;

  //Si esta autorizado para la sucursal dueña
  if (isEditable) {
    veCtaCte = true;
  }

  // Si es COMERCIAL
  if (sector === "14") {
    veCtaCte = true;
  }

  if (controlador) {
    veCtaCte = true;
  }

  // Mostrar en consola el resultado
  // console.log("suc_auth:", sucAuthStr, "id_sucursal:", datosformulario.id_sucursal, "Editable:", isEditable ? "✅ editable" : "❌ no editable");
  // console.log("veCtaCte", veCtaCte, localStorage);

  //Maneja TAB
  const [opcion, setOpcion] = useState("datos");
  const handleChange = (event, newValue) => {
    setOpcion(newValue);
  };

  //Cierra la ficha del cliente
  const handleClose = () => {
    props.ficha(false);
    props.tabla(true);
  };

  // console.log("Props: ", props);
  // console.log("DatosFormularios: ", datosformulario);

  return (
    <div>
      <Container maxWidth={false} disableGutters>
        <Title
          titulo={` ${datosformulario.razon_social} (${
            datosformulario.sisven_id
              ? datosformulario.sisven_id
              : "Sisven ID no registrado"
          })  `}
          handleClose={handleClose}
          pt={0}
        />
        <Box sx={{ width: "100%" }}>
          <Tabs
            variant="fullWidth"
            value={opcion}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
            aria-label="Clientes"
          >
            <Tab value="datos" label="Datos" />
            {datosformulario.inscripcion_iibb === 1 ? (
              <Tab value="impuestos" label="Impuestos" />
            ) : null}
            <Tab value="direcciones" label="Direcciones de entrega" />
            <Tab value="pedidos" label="Pedidos" />
            {datosformulario.precio_especial === 1 ? (
              <Tab value="precioespecial" label="Precio Especial" />
            ) : null}
            {veCtaCte ? (
              <Tab value="cuentacorriente" label="Cuenta Corriente" />
            ) : null}
          </Tabs>
          <br />
        </Box>
        {opcion === "datos" ? (
          <DatosCliEnv
            datos={datosformulario}
            ficha={props.ficha}
            tabla={props.tabla}
            actualizar={props.actualizar}
            isEditable={isEditable}
          />
        ) : null}
        {opcion === "direcciones" ? (
          <DireccionesEntregaEnv cliente={datosformulario} />
        ) : null}
        {opcion === "pedidos" ? (
          <PedidosFicha cliente={datosformulario} />
        ) : null}
        {opcion === "precioespecial" ? (
          <PrecioEspecialCliente cliente={datosformulario} />
        ) : null}

        {opcion === "cuentacorriente" ? (
          // <CuentaCteCliente cliente={datosformulario} />
          // TODO: Aca despues pongo mi page. :)
          <CuentaCorrientePage cliente={datosformulario} />
        ) : null}
        {opcion === "impuestos" ? (
          <IIBBclienteEnvasado cliente={datosformulario} />
        ) : null}
      </Container>
    </div>
  );
}

export default FichaCliEnv;
